import { motion } from "framer-motion";
import { Search, MessageCircle, Handshake, ArrowDown } from "lucide-react";
import { scrollToId } from "../lib/scroll";

const reveal = (delay) => ({
    initial: { opacity: 0, y: 36 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.15 },
    transition: { duration: 0.7, ease: [0.22, 1, 0.36, 1], delay },
});

const STEPS = [
    {
        num: "01",
        color: "bg-brand-forest text-brand-cream",
        icon: Search,
        title: "Jelajahi Katalog",
        desc: "Temukan karya kertas daur ulang favoritmu — cari per nama kreator atau klik kategorinya.",
    },
    {
        num: "02",
        color: "bg-brand-sunshine text-brand-ink",
        icon: MessageCircle,
        title: "Order via WhatsApp",
        desc: "Klik tombol order: kamu langsung terhubung ke nomor WhatsApp yang tertera di produk tersebut.",
    },
    {
        num: "03",
        color: "bg-brand-carrot text-white",
        icon: Handshake,
        title: "Konsultasi & Deal",
        desc: "Diskusi stok, kustomisasi, sampai pengiriman langsung di chat. CS kami siap bantu di 0813-8319-664.",
    },
];

export default function HowItWorks() {
    return (
        <section id="cara-kerja" className="scroll-mt-24 py-16 md:py-24 bg-brand-forestLight/60 border-y-2 border-brand-ink/10">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <motion.div {...reveal(0)} className="flex flex-wrap items-end justify-between gap-6">
                    <div className="max-w-2xl">
                        <span className="inline-block px-3 py-1 rounded-full border-2 border-brand-ink bg-white text-[11px] font-extrabold uppercase tracking-[0.18em] shadow-hard-sm">Cara Kerja</span>
                        <h2 className="mt-5 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold tracking-tight">
                            Order Gampang, <span className="text-brand-forest">3 Langkah</span>
                        </h2>
                    </div>
                    <button
                        data-testid="howitworks-explore-button"
                        onClick={() => scrollToId("katalog")}
                        className="inline-flex items-center gap-2 px-6 py-3.5 rounded-full border-2 border-brand-ink bg-brand-ink text-brand-cream font-display font-bold shadow-hard hover:-translate-y-0.5 hover:shadow-hard-lg transition-all active:translate-y-0 active:shadow-hard"
                    >
                        Mulai Jelajah <ArrowDown className="w-[18px] h-[18px]" strokeWidth={2.6} />
                    </button>
                </motion.div>

                <div className="mt-10 md:mt-14 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-7 items-stretch">
                    {STEPS.map((s, i) => (
                        <motion.article
                            key={s.num}
                            {...reveal(0.1 * i)}
                            whileHover={{ y: -6 }}
                            className="relative rounded-[26px] border-2 border-brand-ink bg-white p-8 shadow-hard-sm hover:shadow-hard transition-shadow flex flex-col"
                        >
                            <div className="flex items-center justify-between">
                                <span className={`grid place-items-center w-16 h-16 rounded-2xl border-2 border-brand-ink font-display text-2xl font-extrabold shadow-hard-sm ${s.color}`}>
                                    {s.num}
                                </span>
                                <s.icon className="w-8 h-8 text-brand-ink/70" strokeWidth={2} />
                            </div>
                            <h3 className="font-display text-xl sm:text-2xl font-bold mt-6">{s.title}</h3>
                            <p className="text-sm text-brand-ink/70 mt-2.5 leading-relaxed">{s.desc}</p>
                        </motion.article>
                    ))}
                </div>
            </div>
        </section>
    );
}
